import React from 'react';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';
import { getWidget } from '@glowforge/gf-styled/components/contentful-views';
import styled from 'styled-components';
import { GridContainer } from '@glowforge/gf-styled/components/grid-container';
import { Header4 } from '@glowforge/gf-styled/components/typography/Typography';

const CallToActionBannerStyled = styled('div')`
  padding: 40px 10px;
  grid-column: main-start / main-end;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.queries.desktopAndUp} {
    flex-direction: row;
  }

  ${Header4} {
    text-align: center;
    --font-weight: 500;
  }

  a {
    margin-top: 20px;
    @media ${(props) => props.theme.queries.desktopAndUp} {
      margin-top: 0;
      margin-left: 20px;
    }
  }
`;

const CallToActionBanner = ({ sections, model }) => {
  const { textStrings } = model;
  const ctaText = textStrings['call-to-action-banner-text'];
  const buttons = sections.map(getWidget);
  const ctaButtons =
    buttons.length > 0 ? <div className='ctaButtons'>{buttons}</div> : null;
  return (
    <GridContainer className='CallToActionBanner fullWidth noMarginBottom'>
      <CallToActionBannerStyled>
        <Header4>{ctaText}</Header4>
        {ctaButtons}
      </CallToActionBannerStyled>
    </GridContainer>
  );
};

CallToActionBanner.propTypes = widgetPropType;

CallToActionBanner.defaultProps = widgetDefaultProps;

export default CallToActionBanner;
